import React from "react";
import { Grid } from "@mui/material";
import {
  BooleanInput,
  maxLength,
  minLength,
  ReferenceArrayInput,
  required,
  SelectArrayInput,
  TextInput,
} from "react-admin";
import { activityRequests } from "api/activityApi";

const SaveForm = () => {
  const validateName = [required(), minLength(3), maxLength(255)];
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={validateName}
        />
      </Grid>
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={validateName}
        />
      </Grid>
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <BooleanInput
          label="Входящ тест"
          source="hasEntryTest"
          defaultValue={true}
        />
      </Grid>
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <ReferenceArrayInput
          source="levels"
          reference={activityRequests.getActivityForeignLanguagesLevelsSelect()}
        >
          <SelectArrayInput
            optionText="name"
            label="Ниво"
            validate={required()}
          />
        </ReferenceArrayInput>
      </Grid>
    </Grid>
  );
};

export default SaveForm;
